<script lang="ts" setup>
import {computed, onMounted, ref} from "vue";
import VProgressBar from "@/scripts/components/app/billing/VProgressBar.vue";
import moment from "moment";
import {Account} from "@/scripts/types/account";

export interface Props {
    account: Account
}

const props = defineProps<Props>();

const endAt = computed(() => {
    if (props.account.currentPlan.label === 'free') {
        return 0
    }

    return moment(props.account.currentPlan.endAt).format("D.M.YYYY")
})

</script>

<template>
    <div>
        <h3 class="text-base font-semibold leading-6 text-gray-900">Текущий план</h3>
        <div class="mt-2 max-w-xl text-sm">
            <div>
                <span class="font-bold text-xl first-letter:capitalize">
                    {{ account.currentPlan.label }}
                </span>
                <span v-if="account.currentPlan.label !== 'free'">
                    (действует до {{ endAt }})
                </span>
            </div>
            <div>
                <div class="mt-6">
                    <v-progress-bar
                        :limit="account.currentPlan.qrCodesLimit"
                        :current="account.statistics.qrCodesCount"
                        label="QR коды"
                    ></v-progress-bar>
                </div>
                <div class="mt-4" v-if="account.currentPlan.label !== 'business'">
                    <v-progress-bar
                        :limit="account.currentPlan.scansLimit"
                        :current="account.statistics.scansCount"
                        label="Сканирований в месяц"
                    ></v-progress-bar>
                </div>
            </div>
        </div>
    </div>
</template>
